export const ON_MESSAGE_FROM_EVENT_LISTENER: string =
  "ON_MESSAGE_FROM_EVENT_LISTENER";
